<template>
	<div class="bold-400">
		<div class="row">
			<div class="col-md-12">
				<div class="white-box" v-if="datatable">
					<div class="row m-b-5">
						<div class="col-lg-6 col-md-4 col-sm-2 col-xs-12">
							<h3 class="box-title pull-left">Productos</h3>
							<div class="visible-xs">
								<div class="btn-group pull-right">
									<button @click="$refs.filterBar.collapse()" type="button" class="btn btn-default" data-toggle="collapse" data-target="#filter">
										<i class="fa fa-list" aria-hidden="true"></i>
									</button>
									<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/products/create'" class="btn btn-success">
										<i aria-hidden="true" class="fa fa-plus"></i>
									</router-link>
								</div>
							</div>
						</div>
						<div class="col-lg-6 col-md-8 col-sm-10 col-xs-12">
							<filter-bar ref="filterBar" :isAuth="isAuth" :user="user"></filter-bar>
							<div class="btn-group pull-right hidden-xs" role="group" aria-label="...">
								<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/products/create'" class="btn btn-success">
									<i aria-hidden="true" class="fa fa-plus"></i>
								</router-link>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
							<loading :active="datatable.loading" class="velmld-overlay-light">
								<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
							</loading>

							<div class="table-responsive">
								<datatable
									ref="datatable"
									:append-params="datatable.moreParams"
									:http-options="datatable.options"
									:css="datatable.css.table"
									:api-url="datatable.api"
									:fields="datatable.fields"
									:per-page="datatable.page"
									:pagination-path="datatable.path"
									:sort-order="datatable.sortOrder"
									@vuetable:pagination-data="onPaginationData"
									@vuetable:loading="loading"
									@vuetable:loaded="loaded">

									<template slot="id" slot-scope="props">
										<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/products/' + props.rowData.id + '/edit'">
											{{ props.rowData.id }}
										</router-link>
									</template>

									<template slot="reference" slot-scope="props">
										<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/products/' + props.rowData.id + '/edit'">
											{{ props.rowData.reference }}
										</router-link>
									</template>

									<template slot="title" slot-scope="props">
										<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/products/' + props.rowData.id + '/edit'">
											{{ props.rowData.title }}
										</router-link>
									</template>

									<template slot="category" slot-scope="props">
										<template v-if="props.rowData.category">
											{{ props.rowData.category.title }}
										</template>
										<template v-else>
											NONE
										</template>
									</template>

									<template slot="provider" slot-scope="props">
										<router-link v-if="props.rowData.provider" :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/providers/' + props.rowData.provider.id + '/edit'">
											{{ props.rowData.provider.name }}
										</router-link>
									</template>

									<template slot="actions" slot-scope="props">
										<div class="btn-group pull-right">
											<button @click="$refs.actions.open(props.rowData)" type="button" class="btn btn-default visible-sm visible-xs">
												<span class="caret"></span>
											</button>
											<div class="dropdown hidden-sm hidden-xs">
												<button :id="'btn-dropdown-invoice-' + props.rowData.id" type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown">
													<span class="caret"></span>
												</button>
												<ul class="dropdown-menu dropdown-menu-right">
													<li>
														<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/products/'+props.rowData.id+'/edit'">
															<i class="ti-pencil-alt fa-fw"></i>
															Editar
														</router-link>
													</li>
													<template v-if="user.hasRole('admin')">
														<li @click="destroy(props.rowData)">
															<a href="javascript:void(0)">
																<i class="icon-trash fa-fw"></i>
																Eliminar
															</a>
														</li>
													</template>
												</ul>
											</div>
										</div>
									</template>

									<template slot="attributes" slot-scope="props">
										<template v-if="props.rowData.attributes">
											<template v-if="props.rowData.attributes.length">
												<button @click="showAttributes(props.rowData)" type="button" class="btn btn-default btn-circle">
													<i class="fa fa-cube"></i>
												</button>
											</template>
										</template>
									</template>

									<template slot="measurement_unit" slot-scope="props">
										<span v-if="props.rowData.total_measurement_unit">
											{{ props.rowData.total_measurement_unit }}
										</span>
										{{ props.rowData.measurement_unit.name }}
									</template>

									<template slot="amount" slot-scope="props">
										{{ props.rowData.amount }}
									</template>

									<template slot="total" slot-scope="props">
										{{ props.rowData.total }}
									</template>

									<template slot="purchase_total" slot-scope="props">
										{{ props.rowData.purchase_total }}
									</template>
								</datatable>
							</div>

							<pagination-info ref="paginationInfo"
							:info-template="$t('interface.datatable.info_template')"
							:noDataTemplate="$t('interface.datatable.no_data_template')">
							</pagination-info>

							<div class="form-inline">
								<div class="form-group">
									<label class="control-label">{{ $t("interface.datatable.records_per_page") }}: </label>
									<div class="input-group">
										<select @change="reload" class="form-control" v-model="datatable.page">
											<option v-for="page in perPages" :value="page.value">{{ page.label }}</option>
										</select>
									</div>
								</div>
							</div>

							<pagination
								ref="pagination"
								:css="datatable.css.pagination"
								@vuetable-pagination:change-page="onChangePage"
								class="pull-right">
							</pagination>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="modal fade in" id="modal-attribute">
			<div class="modal-dialog modal-lg">
				<div v-if="product" class="modal-content">
					<div class="modal-header">
						<button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
						<h4 class="modal-title" id="myLargeModalLabel">
							{{ product.title }}
						</h4>
					</div>
					<div class="modal-body">
						<div v-if="product.attributes">
							<div v-if="product.attributes.length">
								<ul>
									<li v-for="attribute in product.attributes">
										{{ attribute.origin.name }}
										<span v-if="attribute.value">:
											<span v-if="attribute.product_attribute_type_field_id == 1">
												{{ attribute.value.decimal_value }}
											</span>
											<span v-if="attribute.product_attribute_type_field_id == 2">
												{{ attribute.value.integer_value }}
											</span>
											<span v-if="attribute.product_attribute_type_field_id == 3">
												{{ attribute.value.string_value }}
											</span>
										</span>
										<span v-else>
											<span v-if="attribute.values">
												<ul v-if="attribute.values.length">
													<li v-for="value in attribute.values">
														{{ value.name }}
													</li>
												</ul>
											</span>
										</span>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-default" data-dismiss="modal">
							Cerrar
						</button>
					</div>
				</div>
			</div>
		</div>
		<actions @destroy="destroy" ref="actions"></actions>
	</div>
</template>

<script>
	import Vuetable from 'vuetable-2/src/components/Vuetable'
	import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
	import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'

	import FilterBar from './FilterBar'
	import Actions from './Actions'
	import VueElementLoading from 'vue-element-loading'
	import _ from 'lodash'
	import swal from 'sweetalert2'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'datatable': Vuetable,
			'pagination-info': VuetablePaginationInfo,
			'pagination': VuetablePagination,
			'filter-bar': FilterBar,
			'loading': VueElementLoading,
			'actions': Actions,
		},
		data () {
			return {
				perPages: [
					{
						label: 20,
						value: 20,
					},
					{
						label: 50,
						value: 50,
					},
					{
						label: 100,
						value: 100,
					},
					{
						label: 'Todo',
						value: null,
					},
				],
				datatable: {
					api: this.$env.ROOT + '/api/' + this.$lang.getLang() + '/admin/management/products/datatable',
					loading: true,
					moreParams: {
						filter: {
							allowDate: false,
							date: null,
							text: null,
						}
					},
					page: 20,
					path: '',
					sortOrder: [
						{
							field: 'created_at',
							sortField: 'created_at',
							direction: 'desc',
						}
					],
					options: {
						headers: {
							'Authorization': 'Bearer ' + this.$auth.getToken()
						}
					},
					css: {
						table: {
							sortableIcon: 'fa fa-sort',
							tableClass: 'table table-hover table-striped table-condensed',
							ascendingIcon: 'fa fa-caret-up',
							descendingIcon: 'fa fa-caret-down',
						},
						pagination: {
							wrapperClass: "pagination pull-right",
							activeClass: "btn-default disabled",
							disabledClass: "disabled",
							pageClass: "btn btn-default",
							linkClass: "btn btn-default",
							icons: {
								first: "fa fa-fast-backward",
								prev: "fa fa-step-backward",
								next: "fa fa-step-forward",
								last: "fa fa-fast-forward",
							}
						},
					},
					fields: [
						{
							name: '__slot:id',
							title: this.$platform.setting.number_symbol,
							sortField: 'id',
						},
						{
							name: '__slot:reference',
							title: 'Ref.',
							sortField: 'reference',
						},
						{
							name: '__slot:title',
							title: 'Título',
							sortField: 'title',
						},
						{
							name: '__slot:category',
							title: 'Categoría',
						},
						{
							name: '__slot:provider',
							title: 'Proveedor',
						},
						{
							name: '__slot:attributes',
							title: 'Atributos',
						},
						{
							name: '__slot:measurement_unit',
							title: 'Unidades',
						},
						{
							name: '__slot:amount',
							title: 'Importe',
						},
						{
							name: '__slot:total',
							title: 'Precio de venta',
						},
						{
							name: '__slot:purchase_total',
							title: 'Precio de compra',
						},
						{
							name: 'created_at',
							title: 'Fecha',
							callback: function(value) {
								return moment(value).format('DD/MM/YY')
							},
							sortField: 'created_at',
						},
						{
							name: '__slot:actions',
							title: '',
						},
					],
				},

				product: null,
			}
		},
		mounted() {
			this.$events.$on('filterSet', eventData => this.filterSet(eventData))
			this.$events.$on('filterReset', eventData => this.filterReset(eventData))
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.loadQuery()
			},
			loadQuery() {
				if(this.$route.query) {
					if(this.$route.query.text) {
						this.datatable.moreParams.filter.text = this.$route.query.text
					}
					if(this.$route.query.date) {
						this.datatable.moreParams.filter.allowDate = true
						this.datatable.moreParams.filter.date = this.$route.query.date
					}
				}
			},
			reload() {
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
			loading() {
				this.datatable.loading = true
			},
			loaded() {
				this.datatable.loading = false
				this.loadDropdowns()
			},
			onPaginationData (paginationData) {
				this.$refs.paginationInfo.setPaginationData(paginationData)
				this.$refs.pagination.setPaginationData(paginationData)
			},
			onChangePage (page) {
				this.$refs.datatable.changePage(page)
			},
			filterSet: _.debounce(function (filter) {
				this.datatable.moreParams.filter = filter
				if(this.$refs.datatable) {
					this.$nextTick( () => this.$refs.datatable.refresh())
				}
			}, 300),
			filterReset(filter) {
				this.datatable.moreParams.filter = filter
				if(this.$refs.datatable) {
					this.$nextTick( () => this.$refs.datatable.refresh())
				}
			},
			clearFilter() {
				this.datatable.moreParams.filter.allowDate = false
				this.datatable.moreParams.filter.date = null
				this.datatable.moreParams.filter.text = null
				this.$router.replace({'query': null})
			},
			//--
			loadDropdowns() {
				$('.table-responsive').on('show.bs.dropdown', function () {
					$('.table-responsive').css( "overflow", "inherit" )
				});

				$('.table-responsive').on('hide.bs.dropdown', function () {
					$('.table-responsive').css( "overflow", "auto" )
				})
			},
			showAttributes(product) {
				this.product = product
				var modal = $('#modal-attribute')
				modal.modal('show')
			},
			destroy: function(product) {
				var that = this
				var html = '<p>' + that.$t("messages.item_can_not_be_retrieved") + '</p>'
				if(product.product_storages_count > 0) {
					html += '<p>El item está en uso</p>'
				}
				swal.queue([{
					title: that.$t("messages.attention"),
					html: html,
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/management/products/' + product.id)
							.then(response => {
								that.reload()
								swal(response.body.title, response.body.text, response.body.type);
							}).catch(function(response) {
								if(response.status == 409) {
									swal(response.body.title, response.body.text, response.body.type);
								} else {
									swal({
										title: response.statusText,
										text: response.body,
										type: "warning"
									});
								}
							})
						})
					}
				}]).catch(swal.noop)
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/products/views/Datatable.vue